import { ReferenceDataOptionLists } from '../../../constants/reference-data-option-lists';
import { Deserializable } from '../../deserializable';
import { CaseTaskNameDto } from '../case-task-name-dto.model';
import { ApplicantOfferPreferenceDto } from './applicant-offer-preference-dto.model';
import { BasePlaceholderDto } from './base-placeholder-dto';
import { DocumentTypeDto } from './document-type-dto.model';
import { UploadedDocumentDto } from './uploaded-document-dto.model';

export class PlaceholderDto extends BasePlaceholderDto implements Deserializable {
  public AddedBy: string;
  public AddedDate?: Date;
  public AppointmentDate?: Date;
  public AS400DocumentTypeCode: string;
  public AvailableDocumentTypes: Array<DocumentTypeDto>;
  public CurrentUserId: number;
  public ExternalDescription: string;
  public InformationResponse: string;
  public LastModifiedDate?: Date;
  public LinkedTasksInfo: Array<CaseTaskNameDto>;
  public Name: string;
  public Pdf: string;
  public PlaceholderID: number;
  public ProvidedDocumentTypeName: string;
  public Reason: string;
  public ReceivedByPost: boolean;
  public StatusCode: string;
  public UnableToSupplyOptionAvailable: boolean;
  public UploadedDocuments: Array<UploadedDocumentDto>;
  public OfferChannelCode: string;
  public HasOnReceivedNotificationTask: boolean;
  public IsNotificationTaskDisabled: boolean;

  public ApplicantName: string;
  public IsDocument: boolean;
  public IsInformationRequest: boolean;
  public IsAccepted: boolean;
  public IsRejected: boolean;
  public IsPublished: boolean;
  public IsReceived: boolean;
  public IsCreated: boolean;
  public IsUnable: boolean;
  public IsClosed: boolean;
  public IsExclusiveErrorOccurred: boolean;
  public IsOfferPlaceholder: boolean;
  public ApplicantOfferPreferences: Array<ApplicantOfferPreferenceDto>;
  public IsThirdParty: boolean;
  public IsValuation: boolean;
  public IsInstructed: boolean;
  public IsRequested: boolean;
  public IsAppointmentConfirmed: boolean;

  private readonly referenceDataOptionLists = ReferenceDataOptionLists;

  public deserialize(input: any): this {
    Object.assign(this, input);
    this.AvailableDocumentTypes = input.AvailableDocumentTypes
      ? input.AvailableDocumentTypes.map((documentTypeDto: DocumentTypeDto) =>
          new DocumentTypeDto().deserialize(documentTypeDto)
        )
      : [];
    this.LinkedTasksInfo = input.LinkedTasksInfo
      ? input.LinkedTasksInfo.map((caseTaskNameDto: CaseTaskNameDto) =>
          new CaseTaskNameDto().deserialize(caseTaskNameDto)
        )
      : [];
    this.UploadedDocuments = input.UploadedDocuments
      ? input.UploadedDocuments.map((uploadedDocumentDto: UploadedDocumentDto) =>
          new UploadedDocumentDto().deserialize(uploadedDocumentDto)
        )
      : [];
    this.ApplicantOfferPreferences = input.ApplicantOfferPreferences
      ? input.ApplicantOfferPreferences.map((applicantOfferPreferencesDto: ApplicantOfferPreferenceDto) =>
          new ApplicantOfferPreferenceDto().deserialize(applicantOfferPreferencesDto)
        )
      : [];

    this.IsDocument = this.Type === this.referenceDataOptionLists.PlaceholderTypeDocument;
    this.IsInformationRequest = this.Type === this.referenceDataOptionLists.PlaceholderTypeInformationRequest;
    this.IsOfferPlaceholder = this.Type === this.referenceDataOptionLists.PlaceholderTypeOfferDistribution;
    this.IsThirdParty = this.Type === this.referenceDataOptionLists.PlaceholderTypeThirdParty;
    this.IsValuation = this.Type === this.referenceDataOptionLists.PlaceholderTypeValuation;
    this.IsAccepted = this.StatusCode === this.referenceDataOptionLists.PlaceholderStatusAccepted;
    this.IsRejected = this.StatusCode === this.referenceDataOptionLists.PlaceholderStatusRejected;
    this.IsPublished = this.StatusCode === this.referenceDataOptionLists.PlaceholderStatusPublished;
    this.IsReceived = this.StatusCode === this.referenceDataOptionLists.PlaceholderStatusReceived;
    this.IsCreated = this.StatusCode === this.referenceDataOptionLists.PlaceholderStatusCreated;
    this.IsUnable = this.StatusCode === this.referenceDataOptionLists.PlaceholderStatusUnable;
    this.IsClosed = this.StatusCode === this.referenceDataOptionLists.PlaceholderStatusClosed;
    this.IsInstructed = this.StatusCode === this.referenceDataOptionLists.PlaceholderStatusInstructed;
    this.IsRequested = this.StatusCode === this.referenceDataOptionLists.PlaceholderStatusRequested;
    this.IsAppointmentConfirmed =
      this.StatusCode === this.referenceDataOptionLists.PlaceholderStatusAppointmentConfirmed;

    return this;
  }
}
